import { render, staticRenderFns } from "./HeadModule.vue?vue&type=template&id=679c3073&scoped=true&lang=html&"
import script from "./HeadModule.vue?vue&type=script&lang=js&"
export * from "./HeadModule.vue?vue&type=script&lang=js&"
import style0 from "./HeadModule.vue?vue&type=style&index=0&id=679c3073&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679c3073",
  null
  
)

export default component.exports